const invertedMessages = {
  'Pre-Launch Analytics': 'certs.prelaunch.title',
  'Generated:': 'certs.prelaunch.header.generated',
  'Duration:': 'certs.prelaunch.header.duration',
  close: 'certs.prelaunch.close',
};

export default invertedMessages;
